import { HOST_DOMAIN } from '../../utils/domain';
import { getHeadersWithUniqueVisitorId } from '@brandclub/common-ui';

const DOMAIN = HOST_DOMAIN + '/api-rewards';

export const graphqlFetch = async ({
  query,
  variables,
  signal,
  operationName,
}: {
  operationName: string;
  query: string;
  variables?: any;
  signal?: AbortSignal;
}) => {
  const headers = await getHeadersWithUniqueVisitorId();

  const res = await fetch(`${DOMAIN}/graphql?id=${operationName}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables }),
    signal,
  });

  if (res.ok) {
    return await res.json();
  } else {
    throw new Error(`Error fetching graphql ${operationName}`);
  }
};
